/* eslint-disable react-hooks/exhaustive-deps */
import { ApiKeyFetch } from 'api/fetchers/apiKey';
import BreadCurmb from 'components/BreadCrumbMex/BreadCrumb';
import BreadCurmbPasos from 'components/BreadCrumbMex/BreadCrumbTipo2';
import Page from 'components/Page';
import { Vigencia } from 'components/Vigencia/Vigencia';
import { URLS_PHP_8 } from 'constants/urls_v2';
import useCustomToast from 'hooks/useCustomToasts';
import React, { useCallback, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useHistory } from 'react-router';
import { PASOS_BREADCRUMBS } from 'utils/constants';
import PRODUCTOS from 'utils/constants/PRODUCTOS';
import { getQueryParams, mappRutasEmision } from 'utils/funciones';
import Loading from 'wrappers/Loading';

const API = ApiKeyFetch.instance();

const VigenciaAutoPage = () => {
  const history = useHistory();

  const { idPoliza, codProducto } = getQueryParams();

  const { addWarningToast } = useCustomToast();

  const methods = useForm({ mode: 'onChange' });

  const { handleSubmit } = methods;

  const [loading, setLoading] = useState(false);
  const [rutas, setRutas] = useState(null);
  const [fechas, setFechas] = useState({
    fechaFin: null,
    fechaInicio: null,
  });

  const init = useCallback(async () => {
    setLoading(true);
    const Data = { idPoliza };
    try {
      const res = await API.post(URLS_PHP_8.emision.generarVigencia, Data);
      console.log(res);
      if (res?.transaccion) {
        setFechas({
          fechaFin: res?.fechaFin,
          fechaInicio: res?.fechaInicio,
        });
        methods.reset({
          fechaInicioVigencia: new Date(`${res?.fechaInicioVigencia} 12:00:00`),
        });
        setRutas(mappRutasEmision(res?.pasosEmision));
      } else {
        throw new Error('transaccion false');
      }
    } catch (error) {
      addWarningToast('Ha ocurrido un problema al cargar la información');
      return history.push('/');
    }
    setLoading(false);
  }, [idPoliza]);

  useEffect(() => {
    init();
  }, [init]);

  const onClickRegresar = () => {
    history.push(rutas?.vigencia?.goBack);
  };

  const onSubmit = async (data) => {
    setLoading(true);
    data['idPoliza'] = idPoliza;
    const res = await API.post(URLS_PHP_8.emision.guardarVigencia, data);
    if (res?.transaccion) {
      history.push(rutas?.vigencia?.goTo);
    } else if (res?.msgError) {
      addWarningToast(res?.msgError, { autoDismiss: false });
    } else {
      addWarningToast('Ha ocurrido un problema al guardar la vigencia');
    }
    setLoading(false);
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <Loading loading={loading}>
          <div className="cr-content">
            <Page>
              <BreadCurmb {...PASOS_BREADCRUMBS[PRODUCTOS.AUTO].breadCrumb} />
              <BreadCurmbPasos {...PASOS_BREADCRUMBS[codProducto].breadCrumbPasos[8]} />
              <h2 className="display-4 font-mex text-center">Inicio de vigencia de la póliza</h2>
              <Vigencia
                fechaFin={fechas.fechaFin}
                fechaInicio={fechas.fechaInicio}
                regresar={onClickRegresar}
                onClickSiguiente={handleSubmit(onSubmit)}
              />
            </Page>
          </div>
        </Loading>
      </FormProvider>
    </React.Fragment>
  );
};

export default VigenciaAutoPage;
